import React, {Fragment,useState,useEffect,Suspense} from 'react';
import { Table,Row, Col,
  Card, CardBody,
  CardTitle,Button,FormGroup,Label,Input } from 'reactstrap';
import Parametri from '../../parametri';
import VisualizzaVerbale from './VisualizzaVerbale.js';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import Clessidra from '../Clessidra.js';
import {haPersonalizzazione} from '../../funzioni.js';

import Interrogativo from '../../immagini/interrogativo-azzurro.png';


//const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI_INIZIALI = 1;
const STATO_SCHEDA_NUOVA = 2;
const STATO_SCHEDA_VISUALIZZA = 3;
const STATO_ERRORE_CONNESSIONE = 4;
const STATO_SCRIVI_VERBALE = 5;
const STATO_VISUALIZZA_VERBALE = 6;

function SchedaAssemblee(props) {
    
  const { tipo } = props;
  
  const oggiAAAAMMDD = new Date().toLocaleDateString('en-CA'); // en-CA per avere la data nella forma AAAA-MM-DD
  
  const [flagScaricatoDatiAssemblea, setFlagScaricatoDatiAssemblea] = useState(false);

  // elencoConvocati: [
  //   { ID, COGNOME, NOME, NUMERO_TESSERA, EMAIL, POSIZIONI }
  // ]
  const [elencoConvocati, setElencoConvocati] = useState([]);
  const [flagScaricatoElencoConvocati, setFlagScaricatoElencoConvocati] = useState(false);

  const [elencoPresenti, setElencoPresenti] = useState([]);

  // --- DATI PRIMA CONVOCAZIONE ---
  const [dataPrima, setDataPrima] = useState("");     // YYYY-MM-DD
  const [oraPrima, setOraPrima] = useState("");  // HH:mm
  const [luogoPrima, setLuogoPrima] = useState("");

  // --- DATI SECONDA CONVOCAZIONE ---
  const [dataSeconda, setDataSeconda] = useState(""); // YYYY-MM-DD
  const [oraSeconda, setOraSeconda] = useState(""); // HH:mm
  const [luogoSeconda, setLuogoSeconda] = useState("");

  const [dataAssemblea, setDataAssemblea] = useState(""); // YYYY-MM-DD
  const [oraAssemblea, setOraAssemblea] = useState("");  // HH:mm
  const [luogoAssemblea, setLuogoAssemblea] = useState("");

  const [titolo, setTitolo] = useState("");

  const [tipoAssemblea, setTipoAssemblea] = useState("ordinaria"); // "ordinaria" | "straordinaria"

  // --- ORDINE DEL GIORNO (A PUNTI) ---
  const [odg, setOdg] = useState([
  ]);
  // struttura:
  // [{ id: number, testo: string }]

  // --- EMAIL CONVOCAZIONE ---
  const [inviaEmailSubito, setInviaEmailSubito] = useState(true);
  const [oggettoEmail, setOggettoEmail] = useState("");
  const [testoEmail, setTestoEmail] = useState("");
  const [copiaConoscenzaEmail, setCopiaConoscenzaEmail] = useState("");
  
  // in futuro:
  // const [allegati, setAllegati] = useState([]);
  // [{ tipo: "bilancio" | "file", idDocumento, nomeFile }]

  // --- DESTINATARI EMAIL (SELEZIONE) ---
  const [emailSelezionati, setEmailSelezionati] = useState(new Set()); // contiene gli id dei convocati con email selezionata

  // --- AUTO COMPILAZIONE EMAIL ---
  const [oggettoEmailAuto, setOggettoEmailAuto] = useState(true);
  const [testoEmailAuto, setTestoEmailAuto] = useState(true);

  // --- NOTE INTERNE ---
  const [noteInterne, setNoteInterne] = useState("");

  const [verbale, setVerbale] = useState("");

  const [valida,setValida] = useState(1);

  // --- STATO UI / VALIDAZIONE ---
  const [errore, setErrore] = useState("");

  const [statoPagina,setStatoPagina] = useState(STATO_RICERCA_DATI_INIZIALI);
  const [error,setError] = useState('');

  useEffect(() => {
    //if (tipo == "soci") scaricaElencoSoci();
    if (tipo == "direttivo") scaricaElencoDirettivo();
    setErrore("");
    if (!haPersonalizzazione(props.identitaSelezionata, "smtp")) setInviaEmailSubito(false);
  },[])

  useEffect(() => {
    if (statoPagina == STATO_SCRIVI_VERBALE) {
      var testoBase = "L'assemblea nomina quale Presidente:\ne quale segretario verbalizzante:\n\nIl Presidente dichiara aperta l'assemblea e invita i presenti alla discussione sugli argomenti all'ordine del giorno.\n\n";
      {odg.map((x,i)=>
        {
          testoBase += "PUNTO " + (i+1) + ": " + x.testo + "\n\nDISCUSSIONE:\n\nVOTAZIONE:\n\nDELIBERA:\n\n";
        }      
      )}
      testoBase += "Alle ore\nnon essendoci altro argomento da trattare, il Presidente dichiara conclusa l'assemblea.";

      setVerbale(testoBase);
    }
  },[statoPagina])

  useEffect(() => {
    if (flagScaricatoElencoConvocati) {
      if (props.azione=="ins") setStatoPagina(STATO_SCHEDA_NUOVA);
      if (props.azione=="mod") scaricaDatiAssemblea();
    }
  },[flagScaricatoElencoConvocati])

  useEffect(() => {
    if (flagScaricatoDatiAssemblea) setStatoPagina(STATO_SCHEDA_VISUALIZZA);
  },[flagScaricatoDatiAssemblea])

  // Autocompilazione titolo email = titolo
  useEffect(() => {
    if (!inviaEmailSubito) return;
    if (!oggettoEmailAuto) return;
    setOggettoEmail((titolo || "").trim());
  }, [titolo, inviaEmailSubito, oggettoEmailAuto]);

  // Autocompilazione testo email = template (dipende da vari campi)
  useEffect(() => {
    if (!inviaEmailSubito) return;
    if (!testoEmailAuto) return;
    setTestoEmail(generaTestoEmail());
  }, [inviaEmailSubito, testoEmailAuto, tipo, tipoAssemblea, dataPrima, oraPrima, dataSeconda, oraSeconda, luogoPrima, luogoSeconda, odg]);

  function cambiaTestoOdg(id, valore) {
    setOdg((prev) =>
      prev.map((x) => (x.id === id ? { ...x, testo: valore } : x))
    );
  }

  function aggiungiPuntoOdg() {
    setOdg((prev) => {
      const maxId = prev.reduce((m, x) => Math.max(m, x.id), 0);
      return [...prev, { id: maxId + 1, testo: "" }];
    });
  }

  function rimuoviPuntoOdg(id) {
    setOdg((prev) => prev.filter((x) => x.id !== id));
  }

  // passa dall'elenco degli ordini del giorno memorizzati nel backend, tipo ["odg 1", "odg 2"]
  // all'elenco che serve qui nel frontend, cioè un json tipo [{ id: 1, testo: "odg 1" },{ id: 2, testo: "odg 2" }]
  function odgBackendToState(odgRaw) {
    let arr = [];

    if (Array.isArray(odgRaw)) {
      arr = odgRaw;
    } else if (typeof odgRaw === "string") {
      try {
        arr = JSON.parse(odgRaw);
      } catch (e) {
        arr = [];
      }
    }

    return arr.map((testo, index) => ({
      id: index + 1, // numerico
      testo: (testo !== null && testo !== undefined) ? String(testo) : ""
    }));
  }

  function scaricaElencoDirettivo() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"elencoPersoneDirettivo",
          emak: props.emak,
          radioPeriodo: 3,
          dataInizioPeriodo:oggiAAAAMMDD,
          dataFinePeriodo:oggiAAAAMMDD,
          sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){
              setElencoConvocati(valoreDiRitorno.risultatoRitorno[0].sociAnnoInCorso);
              // preseleziona tutti quelli che hanno email
              const s = new Set();
              elencoConvocati.forEach(p => {
                if (p.EMAIL && p.EMAIL.trim() !== "") s.add(p.id);
              });
              setEmailSelezionati(s);
              setFlagScaricatoElencoConvocati(true);
            }
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        );
  }

  function scaricaDatiAssemblea() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"datiAssemblea",
          emak: props.emak,
          idElemento:props.idElemento,
          sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){
              const [datap, orap] = valoreDiRitorno.assemblea.DATA_PRIMA.split("T");
              setDataPrima(datap);
              setOraPrima(orap);
              setLuogoPrima(valoreDiRitorno.assemblea.LUOGO_PRIMA);
              const [datas, oras] = valoreDiRitorno.assemblea.DATA_SECONDA.split("T");
              setDataSeconda(datas);
              setOraSeconda(oras);
              setLuogoSeconda(valoreDiRitorno.assemblea.LUOGO_SECONDA);
              setTipoAssemblea(valoreDiRitorno.assemblea.TIPO_ASSEMBLEA);
              setTitolo(valoreDiRitorno.assemblea.TITOLO);
              
              // creo il json odg, vedi spiegazione sulla funzione odgBackendToState
              setOdg(odgBackendToState(valoreDiRitorno.assemblea.JSON_ODG));
              
              // tengo in elencoConvocati solo quelli che sono stati davvero convocati.
              // Effetto collaterale: se uno era convocato ma è stato cancellato dall'anagrafica,
              // non compare più nell'elenco. E' accettabile perché nessuno dovrebbe essere
              // cancellato dall'elenco iscritti, dovrebbe solo essere indicato che non è socio attivo.
              // Da backend arriva un elenco di id separati da virgola: con questo costruisco un Set:

              const convocatiSet = new Set(
                valoreDiRitorno.assemblea.CONVOCATI
                  .split(",")
                  .map(x => parseInt(x, 10))
                  .filter(x => !isNaN(x))
              );
              // ora setto elencoConvocati con il valore precedente (prev) filtrato secondo la
              // condizione di tenere un elemento se il Set convocatiSet contiene l'id di questo elemento.
              // Ci vuole il parseInt perché in elencoConvocato l'ID è stringa (arriva così da backend)
              setElencoConvocati(prev =>
                prev.filter(c => convocatiSet.has(parseInt(c.ID)))
              );
              setOggettoEmail(valoreDiRitorno.assemblea.EMAIL_OGGETTO);
              setTestoEmail(valoreDiRitorno.assemblea.EMAIL_TESTO);
              setNoteInterne(valoreDiRitorno.assemblea.NOTE);

              const [dataa, oraa] = valoreDiRitorno.assemblea.DATA_ASSEMBLEA.split("T");
              setDataAssemblea(dataa);
              setOraAssemblea(oraa);
              // se non è ancora stata definita data e ora dell'assemblea, ci metto la data della seconda convocazione come default
              if (valoreDiRitorno.assemblea.DATA_ASSEMBLEA == "") {
                setDataAssemblea(datas); 
                setOraAssemblea(oras);
                setLuogoAssemblea(valoreDiRitorno.assemblea.LUOGO_SECONDA);
              }
              
              setVerbale(valoreDiRitorno.assemblea.VERBALE);

              setFlagScaricatoDatiAssemblea(true);
            }
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        );
  }

  function invia_verbale_backend() {
    const stringaPresentiID = elencoPresenti
      .map(item => item.ID)
      .join(',');

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({op:"verbaliAssembleeIns",
      emak: props.emak,
      id: props.idElemento,
      dataAssemblea: dataAssemblea+"T"+oraAssemblea,        
      luogoAssemblea: luogoAssemblea.trim(),
      odg: odg.map((x) => x.testo.trim()).filter(Boolean),
      presenti: stringaPresentiID,
      verbale: verbale.trim(),
      sessionId:props.sessionId})
    };

    fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
      .then(risposta => risposta.json())
      .then(
        (valoreDiRitorno) => {
          if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
            alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
          }
          if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
          if(valoreDiRitorno.risultatoOperazione===1){              
            props.callback();}
        },
      (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
    );
  } 
  
  function formattaDataIT(yyyy_mm_dd) {
    if (!yyyy_mm_dd) return "";
    const p = yyyy_mm_dd.split("-");
    if (p.length !== 3) return yyyy_mm_dd;
    return p[2] + "/" + p[1] + "/" + p[0];
  }

  function generaTestoEmail() {
    const destinatari = (tipo === "direttivo") ? "componenti del direttivo" : "signori soci";
    const tipoAss = (tipoAssemblea === "straordinaria") ? "straordinaria" : "ordinaria";

    const riga1 = `Si avvisano i ${destinatari} che è convocata l'assemblea ${tipoAss}.`;
    const riga2 = `Prima convocazione il ${formattaDataIT(dataPrima)} alle ${oraPrima} presso ${luogoPrima || ""}.`;
    const riga3 = `Seconda convocazione il ${formattaDataIT(dataSeconda)} alle ${oraSeconda} presso ${luogoSeconda || ""}.`;
    const riga4 = `Per discutere e deliberare sul seguente ordine del giorno:`;

    const odgPulito = odg.map(x => (x.testo || "").trim()).filter(Boolean);
    const righeOdg = odgPulito.length
      ? odgPulito.map((t, i) => `${i + 1}) ${t}`)
      : ["- (ordine del giorno non definito)"];

    return [
      riga1,
      "",
      riga2,
      riga3,
      riga4,
      ...righeOdg,
      "",
      "Cordiali saluti.",
    ].join("\n");
  }

  function isPresente(id) {
    return elencoPresenti.indexOf(id) >= 0;
  }

  function togglePresente(id) {
    setElencoPresenti((prev) => {
      if (prev.indexOf(id) >= 0) {
        return prev.filter((x) => x !== id);
      }
      return [...prev, id];
    });
  }

  function segnaTuttiPresenti() {
    setElencoPresenti(elencoConvocati.map((x) => x.ID));
  }

  function segnaTuttiAssenti() {
    setElencoPresenti([]);
  }

  if (statoPagina == STATO_RICERCA_DATI_INIZIALI) {
    return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/></div>)
  }

  if (statoPagina == STATO_ERRORE_CONNESSIONE) {
    return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Errore nell'elaborazione della richiesta</div>)
  }

  if (statoPagina == STATO_SCHEDA_NUOVA) {

    function valida() {
      if (!dataPrima) return "Inserisci la data della 1ª convocazione.";
      if (!oraPrima) return "Inserisci l'ora della 1ª convocazione.";
      if (!dataSeconda) return "Inserisci la data della 2ª convocazione.";
      if (!oraSeconda) return "Inserisci l'ora della 2ª convocazione.";
      if (dataSeconda < dataPrima) return "La 2ª convocazione non può essere prima della 1ª.";
      if (!luogoPrima.trim()) return "Inserisci il luogo della prima convocazione.";
      if (!luogoSeconda.trim()) return "Inserisci il luogo della seconda convocazione.";
      if (!titolo.trim()) return "Inserisci un titolo/oggetto dell'assemblea.";
      const odgPulito = odg.map((x) => x.testo.trim()).filter(Boolean);
      if (odgPulito.length === 0) return "Inserisci almeno un punto nell'ordine del giorno.";
      if (elencoConvocati.length === 0) return "Elenco convocati vuoto.";
      if (inviaEmailSubito) {
        const selezionati = elencoConvocati.filter(c => c.EMAIL && c.EMAIL.trim() !== "" && emailSelezionati.has(c.id));
        if (selezionati.length === 0) return "Seleziona almeno un destinatario con email.";
        if (!oggettoEmail.trim()) return "Inserisci l'oggetto email.";
        if (!testoEmail.trim()) return "Inserisci il testo email.";
      }
      return "";
    }

    function invia_convocazione_backend() {
      const msg = valida();
      if (msg) {
        alert(msg);
        setErrore(msg);
        return;
      }
      setErrore("");

      const destinatariEmail = elencoConvocati.filter(c => c.EMAIL && c.EMAIL.trim() !== "" && emailSelezionati.has(c.id));

      const stringaConvocatiID = elencoConvocati
        .map(item => item.ID)
        .join(',');

      const stringaDestinatariID = destinatariEmail
        .map(item => item.ID)
        .join(',');

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"aggiungiAssemblea",
        emak: props.emak,
        tipo: tipo,
        tipoAssemblea: tipoAssemblea,
        dataPrima: dataPrima+"T"+oraPrima,        
        dataSeconda: dataSeconda+"T"+oraSeconda,
        luogoPrima: luogoPrima.trim(),
        luogoSeconda: luogoSeconda.trim(),
        titolo: titolo.trim(),
        odg: odg.map((x) => x.testo.trim()).filter(Boolean),
        convocati: stringaConvocatiID,
        email: {
          inviaEmailSubito,
          oggetto: oggettoEmail.trim(),
          testo: testoEmail,
          destinatari: stringaDestinatariID,
          copiaConoscenzaEmail: copiaConoscenzaEmail
        },
        noteInterne: noteInterne.trim(),
        sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){              
              props.callback();}
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
      );
    }

    if (props.azione == "ins") {
      return (
        <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
        <CardBody>
          <CardTitle>
            Nuova Convocazione {tipo === "direttivo" ? "Direttivo" : "Assemblea Soci"}
            &nbsp;
            {/* se vuoi l’help come nelle altre pagine */}
            {/* <img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagModaleInfo(true)}/> */}
          </CardTitle>

          {errore ? (
            <Row style={{ marginLeft: 20, marginRight: 20 }} >
              <Col style={{ color: "red", padding: 10 }}>
                <b>{errore}</b>
              </Col>
            </Row>
          ) : (
            ""
          )}

          {/* ======= DATI CONVOCAZIONE ======= */}
          {/*
          <Row
            style={{ marginLeft: 20, marginRight: 20, backgroundColor: "#99cbff" }}
            
          >
            <Col>
              <b>
                <center>Dati Convocazione</center>
              </b>
            </Col>
          </Row>
          */}
          <div className='schedaSottotitolo'>Dati Convocazione</div>

          <Row style={{ marginLeft: 5, marginRight: 5 }}>
            <Col md="5">
              <FormGroup>
                <Label for="dataPrima">1ª convocazione</Label>
                <div style={{display:'flex', flexDirection:'row'}}>
                  <Input
                    maxLength={10}
                    type="date"
                    name="dataPrima"
                    id="dataPrima"
                    value={dataPrima}
                    onChange={(e) => setDataPrima(e.target.value)}
                  />
                  <Input
                    type="time"
                    name="oraPrima"
                    id="oraPrima"
                    value={oraPrima}
                    onChange={(e) => setOraPrima(e.target.value)}
                  />
                </div>
              </FormGroup>
            </Col>

            <Col md="7">
              <FormGroup>
                <Label for="luogoPrima">Presso</Label>
                <Input
                  type="text"
                  value={luogoPrima}
                  placeholder="indirizzo oppure, ad es., Sede Sociale"
                  onChange={(e) => {setLuogoPrima(e.target.value); if (luogoSeconda == "" || luogoPrima==luogoSeconda) setLuogoSeconda(e.target.value)}}
                />
              </FormGroup>
            </Col>          

          </Row>
          <Row style={{ marginLeft: 5, marginRight: 5 }}>

            <Col md="5">
              <FormGroup>
                <Label for="dataSeconda">2ª convocazione</Label>
                <div style={{display:'flex', flexDirection:'row'}}>
                  <Input
                    maxLength={10}
                    type="date"
                    name="dataSeconda"
                    id="dataSeconda"
                    value={dataSeconda}
                    onChange={(e) => setDataSeconda(e.target.value)}
                  />
                  <Input
                    type="time"
                    name="oraSeconda"
                    id="oraSeconda"
                    value={oraSeconda}
                    onChange={(e) => setOraSeconda(e.target.value)}
                  />
                </div>
              </FormGroup>
            </Col>

            <Col md="7">
              <FormGroup>
                <Label for="luogoPrima">Presso</Label>
                <Input
                  type="text"
                  value={luogoSeconda}
                  placeholder="indirizzo oppure, ad es., Sede Sociale"
                  onChange={(e) => {setLuogoSeconda(e.target.value);}}
                />
              </FormGroup>
            </Col>          
          </Row>

          <Row style={{ marginLeft: 5, marginRight: 5 }}>
            <Col md="3">
              <FormGroup>
                <Label for="tipoAssemblea">Tipo assemblea</Label>
                <select
                  className="inputStandard" 
                  type="select"
                  name="tipoAssemblea"
                  id="tipoAssemblea"
                  value={tipoAssemblea}
                  onChange={(e) => setTipoAssemblea(e.target.value)}
                >
                  <option value="ordinaria">Ordinaria</option>
                  <option value="straordinaria">Straordinaria</option>
                </select>
              </FormGroup>
            </Col>

            <Col md="9">
                <Label for="titolo">Argomento</Label>
                <Input
                  type="text"
                  name="titolo"
                  id="titolo"
                  value={titolo}
                  placeholder="Es. Convocazione assemblea ordinaria"
                  onChange={(e) => setTitolo(e.target.value)}
                />
            </Col>
          </Row>        

          {/* ======= ORDINE DEL GIORNO ======= */}        
          <div className='schedaSottotitolo'>Ordine del Giorno</div>

          <Row style={{ marginLeft: 5, marginRight: 5 }}>
            <Col style={{ padding: 10 }}>
              {odg.map((punto, idx) => (
                <Row key={punto.id} style={{ marginBottom: 10 }}>
                  <Col md="1" style={{ paddingTop: 8 }}>
                    <b>{idx + 1}.</b>
                  </Col>
                  <Col md="9">
                    <Input
                      type="text"
                      value={punto.testo}
                      placeholder="Inserisci punto ODG..."
                      onChange={(e) => cambiaTestoOdg(punto.id, e.target.value)}
                    />
                  </Col>
                  <Col md="2">
                    <Button
                      color="danger"
                      onClick={() => rimuoviPuntoOdg(punto.id)}
                      style={{ width: "100%" }}
                    >
                      Rimuovi
                    </Button>
                  </Col>
                </Row>
              ))}

              <Button color="success" onClick={() => aggiungiPuntoOdg()}>
                + Aggiungi punto
              </Button>
            </Col>
          </Row>

          {/* ======= CONVOCATI (SELEZIONE EMAIL) ======= */}
          <div className='schedaSottotitolo'>Convocati: {elencoConvocati.length}</div>

          <Row style={{ marginLeft: 5, marginRight: 5 }}>
            <Col>
              {elencoConvocati.length === 0 ? (
                <div><b>Elenco convocati vuoto (verifica che esistano {tipo=="soci"?"soci":"componenti del direttivo"}).</b></div>
              ) : (
                <div style={{ paddingLeft:10, paddingRight: 10 }}>
                  {elencoConvocati.map((c, i) => {
                    const haEmail = c.EMAIL && c.EMAIL.trim() !== "";
                    const selezionato = emailSelezionati.has(c.id);

                    return (
                      <Row key={c.id}>
                        <Col md="6" style={{borderBottom: i==elencoConvocati.length-1 ? "" : "1px solid #D0D0D0"}}>
                          <b>{c.COGNOME} {c.NOME} {c.NUMERO_TESSERA!="" && (c.NUMERO_TESSERA)}</b>
                          <div style={{fontSize:12}}>{c.POSIZIONI}</div>
                        </Col>

                        <Col md="6" style={{borderBottom: i==elencoConvocati.length-1 ? "" : "1px solid #D0D0D0"}}>
                            {inviaEmailSubito ? (
                            haEmail ? (
                              <Input
                                type="checkbox"
                                checked={selezionato}
                                onChange={(e) => {
                                  const nuovo = new Set(emailSelezionati);
                                  if (e.target.checked) nuovo.add(c.id);
                                  else nuovo.delete(c.id);
                                  setEmailSelezionati(nuovo);
                                }}
                              />
                            ) : (
                              <Input type="checkbox" disabled />
                            )
                          ) : ""}

                          <i>{haEmail ? c.EMAIL : <span style={{color:"#FF5050"}}>non ha email</span>}</i>
                        </Col>

                      </Row>
                    );
                  })}
                </div>
              )}
            </Col>
          </Row>

          {inviaEmailSubito &&
            <div style={{ padding: 10, display: "flex", gap: 10 }}>
              <Button
                color="primary"
                onClick={() => {
                  const s = new Set();
                  elencoConvocati.forEach(p => {
                    if (p.EMAIL && p.EMAIL.trim() !== "") s.add(p.id);
                  });
                  setEmailSelezionati(s);
                }}
              >
                Seleziona tutti
              </Button>

              <Button
                color="secondary"
                onClick={() => setEmailSelezionati(new Set())}
              >
                Seleziona nessuno
              </Button>
            </div>
          }

          {/* ======= EMAIL + ALLEGATI (FUTURI) ======= */}        
          <div className='schedaSottotitolo'>Invio Email</div>

          <Row style={{ marginLeft: 5, marginRight: 5 }}>
            <Col style={{ padding: 10 }}>
              {haPersonalizzazione(props.identitaSelezionata, "smtp") ? 
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={inviaEmailSubito}
                    onChange={(e) => setInviaEmailSubito(e.target.checked)}
                  />{" "}
                  Invia email ai {elencoConvocati.filter(c => c.EMAIL && c.EMAIL.trim() !== "" && emailSelezionati.has(c.id)).length} convocati selezionati
                </Label>
              </FormGroup>
              :
                <div style={{color:"#FF0000"}}>Impossibile inviare email di convocazione, prima definisci l'SMTP in Impostazioni - Società</div>
              }

              <Row style={{ marginTop: 10 }}>
                <Col md="12">
                  <FormGroup>
                    <Label for="oggettoEmail">Oggetto email</Label>
                    <Input
                      type="text"
                      name="oggettoEmail"
                      id="oggettoEmail"
                      value={oggettoEmail}
                      onChange={(e) => { setOggettoEmailAuto(false); setOggettoEmail(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label for="testoEmail">Testo email</Label>
                    <Input
                      type="textarea"
                      name="testoEmail"
                      id="testoEmail"
                      rows="8"
                      value={testoEmail}
                      onChange={(e) => { setTestoEmailAuto(false); setTestoEmail(e.target.value); }}
                    />

                    <div style={{ marginTop: 10 }}>
                      <Button
                        color="primary"
                        onClick={() => { setTestoEmailAuto(true); setTestoEmail(generaTestoEmail()); }}
                      >
                        Rigenera automaticamente oggetto e testo
                      </Button>
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              {inviaEmailSubito &&
                <Row style={{ marginTop: 10 }}>
                  <Col md="12">
                    <FormGroup>
                      <Label for="copiaConoscenzaEmail">Manda convocazione in copia a questi indirizzi email (separati da virgola)</Label>
                      <Input
                        type="text"
                        name="copiaConoscenzaEmail"
                        id="copiaConoscenzaEmail"
                        value={copiaConoscenzaEmail}
                        onChange={(e) => { setCopiaConoscenzaEmail(e.target.value); }}
                      />
                    </FormGroup>
                  </Col>
                </Row>                
              }
            </Col>
          </Row>

          {/* ======= NOTE INTERNE ======= */}
          <div className='schedaSottotitolo'>Note Interne</div>
          <Row style={{ marginLeft: 5, marginRight: 5 }}>
            <Col style={{ padding: 10 }}>
              <FormGroup>
                <Input
                  type="textarea"
                  name="noteInterne"
                  id="noteInterne"
                  rows="4"
                  value={noteInterne}
                  onChange={(e) => setNoteInterne(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* ======= BOTTONI ======= */}
          <div style={{ marginTop: 15 }}>
            <Button color="success" onClick={() => invia_convocazione_backend()}>
              Memorizza{inviaEmailSubito && " e invia convocazione"}
            </Button>
            <Button
              color="secondary"
              className="bottoneMargineASinistra"
              onClick={() => props.callback()}
            >
              Annulla
            </Button>
          </div>
        </CardBody>
        </div>
      );
    }
  }

  if (statoPagina == STATO_SCHEDA_VISUALIZZA) {
    return (
      <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
        <CardBody>
          <CardTitle>
            Assemblea {tipoAssemblea} {props.tipo === "direttivo" ? "Direttivo" : "Soci"}
          </CardTitle>
          <div style={{fontSize:20}}>{titolo}</div>
        </CardBody>
        <div>
          <b>Prima convocazione:</b> <TrasformaDateAUmano data={dataPrima}/> ore {oraPrima} presso {luogoPrima}
        </div>
        <div>
          <b>Seconda convocazione:</b> <TrasformaDateAUmano data={dataSeconda}/> ore {oraSeconda} presso {luogoSeconda}
        </div>
        <div>
          <b>Ordine del giorno:</b>
          <ol>
          {odg.map((x,i)=>(
            <li>{x.testo}</li>
          ))}
          </ol>
        </div>
        <div>
          <b>Convocati:</b> {elencoConvocati.length} {props.tipo=="direttivo"?"membri del direttivo":"soci"}
        </div>
        {emailSelezionati.length &&
          <div>
            <b>Convocazione inviata via mail a:</b> {emailSelezionati.length} {props.tipo=="direttivo"?"membri del direttivo":"soci"}
          </div>
        }

        <div>
          <b>Verbale:</b> {verbale=="" ? 
            <Button color="success" onClick={() => setStatoPagina(STATO_SCRIVI_VERBALE)}>
              Scrivi verbale
            </Button>
          :
            <div style={{display:'flex', flexDirection:'row'}}>
              <Button color="success" onClick={() => setStatoPagina(STATO_VISUALIZZA_VERBALE)}>
                Vedi verbale
              </Button>
              <Button color="success" onClick={() => aggiungiPuntoOdg()}>
                Modifica verbale
              </Button>
            </div>          
          }
        </div>
      </div>
    )
  }

  if (statoPagina == STATO_SCRIVI_VERBALE) {
    const numPresenti = elencoPresenti.length;
    const numConvocati = elencoConvocati.length;
    var convocazione = "";
    if (dataAssemblea==dataPrima && oraAssemblea==oraPrima) convocazione = " in prima convocazione";
    if (dataAssemblea==dataSeconda && oraAssemblea==oraSeconda) convocazione = " in seconda convocazione";

    return (
      <CardBody>
        <CardTitle>
          Verbale assemblea {tipoAssemblea}{" "}
          {props.tipo === "direttivo" ? "Direttivo" : "Soci"}
        </CardTitle>

        <div style={{display:'flex', alignItems: "center", paddingBottom:10}}>
          <div style={{paddingRight:5, whiteSpace: 'nowrap'}}>Il giorno</div>
          <Input
            maxLength={10}
            type="date"
            value={dataAssemblea}
            onChange={(e) => setDataAssemblea(e.target.value)}
          />{" "}
          <div style={{paddingRight:5, paddingLeft:5, whiteSpace: 'nowrap'}}>alle ore</div>
          <Input
            type="time"
            value={oraAssemblea}
            onChange={(e) => setOraAssemblea(e.target.value)}
          />
        </div>
        <div style={{display:'flex', alignItems: "center", paddingBottom:10}}>
          <div style={{paddingRight:5, whiteSpace: 'nowrap'}}>presso</div>
          <Input
            type="text"
            value={luogoAssemblea}
            placeholder="indirizzo oppure, ad es., Sede Sociale"
            onChange={(e) => setLuogoAssemblea(e.target.value)}
          />
        </div>
        <div style={{paddingBottom:10}}>
          si è riunita {convocazione} l'assemblea {tipoAssemblea}{" "}
          {props.tipo === "direttivo" ? "del consiglio direttivo" : "dei soci"} della{" "}
          <b>{props.identitaSelezionata.societa}</b>, per discutere e deliberare sul seguente <b>ordine del giorno:</b>
        </div>
        <div>
          <ol>
            {odg.map((x, i) => (
              <li key={i}>{x.testo}</li>
            ))}
          </ol>
        </div>

        {/* ====== SELEZIONE PRESENTI ====== */}
        <div style={{ marginTop: 16, marginBottom: 8, fontWeight: "bold" }}>
          {numPresenti!=1 ?
            <>Sono presenti i seguenti {numPresenti} {props.tipo === "direttivo" ? "consiglieri" : "soci"} su {numConvocati} convocati:</>
          : 
            <>E' presente il seguente {props.tipo === "direttivo" ? "consigliere" : "socio"} su {numConvocati} convocati:</>
          }
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>

          <div
            onClick={segnaTuttiPresenti}
            style={{
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: 6,
              cursor: "pointer",
              userSelect: "none",
              background: "#f7f7f7",
            }}
          >
            Tutti presenti
          </div>

          <div
            onClick={segnaTuttiAssenti}
            style={{
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: 6,
              cursor: "pointer",
              userSelect: "none",
              background: "#f7f7f7",
            }}
          >
            Tutti assenti
          </div>

          <div style={{ fontSize: 12, opacity: 0.8 }}>
            (Clicca un nominativo per presente/assente)
          </div>
        </div>

        <div style={{ border: "1px solid #ddd", borderRadius: 8, overflow: "hidden" }}>
          {elencoConvocati.map((p, idx) => {
            const presente = isPresente(p.ID);

            return (
              <div
                key={p.ID}
                onClick={() => togglePresente(p.ID)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 12px",
                  cursor: "pointer",
                  userSelect: "none",
                  borderTop: idx === 0 ? "none" : "1px solid #eee",
                  background: presente ? "#d9f7d9" : "#f2f2f2",
                }}
                title="Clicca per cambiare stato presente/assente"
              >
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <div>
                    <b>{p.COGNOME} {p.NOME} {p.NUMERO_TESSERA!="" && (p.NUMERO_TESSERA)}</b>
                    <div style={{fontSize:12}}>{p.POSIZIONI}</div>
                  </div>
                </div>

                <div
                  style={{
                    padding: "4px 10px",
                    borderRadius: 999,
                    border: "1px solid #ccc",
                    background: presente ? "#bff0bf" : "#e6e6e6",
                    fontWeight: "bold",
                    minWidth: 90,
                    textAlign: "center",
                  }}
                >
                  {presente ? "PRESENTE" : "ASSENTE"}
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: 12, marginBottom:12 }}>
          Essendo presenti {numPresenti} {props.tipo === "direttivo" ? "consiglieri" : "soci"} su{" "}
          {elencoConvocati.length} l'assemblea è{" "}
          <select value={valida} onChange={(e) => setValida(e.target.value)}>
            <option value={1}>regolarmente costituita</option>
            <option value={0}>non valida</option>
          </select>
        </div>

        <textarea rows={40} cols={80} value={verbale} onChange={(e)=>setVerbale(e.target.value)} />

          {/* ======= BOTTONI ======= */}
          <div style={{ marginTop: 15 }}>
            <Button color="success" onClick={() => invia_verbale_backend()}>
              Memorizza
            </Button>
            <Button
              color="secondary"
              className="bottoneMargineASinistra"
              onClick={() => props.callback()}
            >
              Annulla
            </Button>
          </div>
      </CardBody>
    )

    

  }

  if (statoPagina == STATO_VISUALIZZA_VERBALE) {
    const numPresenti = elencoPresenti.length;
    const numConvocati = elencoConvocati.length;
    var convocazione = "";
    if (dataAssemblea==dataPrima && oraAssemblea==oraPrima) convocazione = " in prima convocazione";
    if (dataAssemblea==dataSeconda && oraAssemblea==oraSeconda) convocazione = " in seconda convocazione";
    return (
      <VisualizzaVerbale 
        {...props}
        azione={"visualizza"}
        dataAssemblea={dataAssemblea}
        oraAssemblea={oraAssemblea}
        luogoAssemblea={luogoAssemblea}
        tipoAssemblea={tipoAssemblea}
        convocazione={convocazione}
        elencoPresenti={elencoPresenti}        
        verbale={verbale}
        callback={()=>setStatoPagina(STATO_SCHEDA_VISUALIZZA)}
      />
    )
  }
  
  
  return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Assemblee: Pagina non trovata ({statoPagina})</div>)
}
export default SchedaAssemblee;